import { Component } from '@angular/core';
import { SITE_DATA } from '../productization/default.constant';

@Component({
    selector: 'app-privacy-policy',
    templateUrl: './privacy-policy.component.html',
    styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent {
	public customData: any = SITE_DATA.privacyPolicy;
}
